import * as _ from "lodash";
import * as $ from "jquery";
import {BaseGenericModal, BaseGenericModalOptions} from "./_BaseGenericModal";
import {DashboardCollection} from "../../collections/Dashboards";
import {Utils} from "../../common/utils";

export interface GenericDashboardSelectModalOptions extends Omit<BaseGenericModalOptions, 'name'> {
    dashboardCollection: DashboardCollection;
    currentDashboardId?: number;
    name?: string; // Optional, not used in dashboard selection modal
    noteHtml?: string; // Optional note shown below the select (e.g. clone-tab disclaimer)
}

export class GenericDashboardSelectModal extends BaseGenericModal {

    public options: GenericDashboardSelectModalOptions;
    private template = _.template(require('templates/modals/genericDashboardSelect.html'));

    constructor(options: GenericDashboardSelectModalOptions) {
        super(<any> _.extend({
            tagName: "div",
            events: {
                'shown.bs.modal #genericDashboardSelectModal': 'handleModalShown',
                'hidden.bs.modal #genericDashboardSelectModal': 'handleModalHidden',
                'click .generic-dashboard-select-modal-submit': 'handleSubmit',
                'change .generic-dashboard-select-modal-select': 'handleSelectChange'
            }
        }, options));
        this.genericIdSelector = 'genericDashboardSelectModal';
    }

    render() {
        var text = this.options.text || "Choose a target dashboard:";
        var buttonText = this.options.buttonText || "Move";
        var titleText = this.options.titleText;
        var currentDashboardId = this.options.currentDashboardId;
        var noteHtml = this.options.noteHtml;

        this.$el.html(this.template({
            elementId: 'genericDashboardSelectModal',
            text: text,
            buttonText: buttonText,
            titleText: titleText,
            dashboards: this.options.dashboardCollection.models,
            currentDashboardId: currentDashboardId,
            noteHtml: noteHtml
        }));
        return this;
    };

    handleSubmit() {
        var select = this.$('.generic-dashboard-select-modal-select');
        var selectedDashboardId = Number(select.val());
        
        if (!selectedDashboardId) {
            return;
        }

        this.setFormSubmitted();

        $.when(this.options.func(selectedDashboardId)).done(() => {
            this.hide();
        }).fail(() => {
            this.setFormError();
        });
    }

    handleSelectChange() {
        // Enable/disable submit button based on selection
        var selectedDashboardId = Number(this.$('.generic-dashboard-select-modal-select').val());
        var submitButton = this.$('.generic-dashboard-select-modal-submit');
        
        if (selectedDashboardId && selectedDashboardId !== this.options.currentDashboardId) {
            submitButton.prop('disabled', false);
        } else {
            submitButton.prop('disabled', true);
        }
    }

    handleModalShown() {
        // Initialize Select2 for searchable dropdown
        // Use dropdownParent to ensure dropdown is properly attached to modal
        const modalElement = this.$('#' + this.genericIdSelector);
        var select = this.$('.generic-dashboard-select-modal-select');
        var dashboardData = this.options.dashboardCollection.models.map((dashboard) => {
            return {
                id: dashboard.get('id'),
                text: dashboard.get('name')
            };
        });
        
        // Initialize Select2 with search functionality and dropdownParent
        (<any>select).select2(_.extend({
            data: dashboardData,
            placeholder: 'Select a dashboard...',
            dropdownParent: modalElement
        }, Utils.Select2.defaultOptions));
        
        // Bind change event for Select2
        select.on('select2:select', () => {
            this.handleSelectChange();
        });
        
        // Set initial value if currentDashboardId is provided
        if (this.options.currentDashboardId) {
            select.val(this.options.currentDashboardId).trigger('change');
        }
        
        // Set initial state of submit button
        var selectedDashboardId = Number(select.val());
        var submitButton = this.$('.generic-dashboard-select-modal-submit');
        
        if (selectedDashboardId && selectedDashboardId !== this.options.currentDashboardId) {
            submitButton.prop('disabled', false);
        } else {
            submitButton.prop('disabled', true);
        }
    }

    handleModalHidden() {
        // Clean up Select2 when modal is hidden
        var select = this.$('.generic-dashboard-select-modal-select');
        if ((<any>select).data('select2')) {
            try {
                (<any>select).select2('destroy');
            } catch (e) {
                // Ignore errors if select2 is not properly initialized
            }
        }
        super.handleModalHidden();
    }
}




// WEBPACK FOOTER //
// ./srv/public/js/views/modals/GenericDashboardSelectModal.ts